<template>
  <div class="Sidebar" :class="{ 'is-hidden': isHidden }">
    <Categories
      title="Categories"
      :categories="languages"
      :has-add-button="true"
      @select="selectLanguage"
      @context-menu="handleShowContextMenu"
      @add="handleAddLanguage"
      @update="handleUpdateLanguage"
      @finish-edit-mode="handleFinishEditMode"
    />
    <Categories title="Tags" :categories="tags" @select="selectTag" />
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 303 349" v-bind:svg-inline="''" v-bind:class="'Logo'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="none" fill-rule="evenodd" stroke="#F4B865" stroke-width="20"><path d="M151.5 12l140.729 81.25v162.5L151.5 337 10.771 255.75V93.25z"/><path d="M151.5 12l44.795 25.863v51.725L151.5 115.451l-44.795-25.863V37.863zM246.711 177.704l44.796 25.863v51.725l-44.796 25.863-44.795-25.863v-51.725zM56.289 178.62l44.795 25.862v51.726L56.289 282.07l-44.796-25.862v-51.726zM107.556 93.479l44.796 25.863v51.725l-44.796 25.863-44.795-25.863v-51.725zM199.106 93.479l44.795 25.863v51.725l-44.795 25.863-44.796-25.863v-51.725zM151.5 175.873l44.795 25.863v51.725L151.5 279.324l-44.795-25.863v-51.725z"/></g></svg>
    <BaseContextMenu
      :visible="showContextMenu"
      :top="contextMenuTop"
      :left="contextMenuLeft"
      :items="contextMenuItems"
      @click="handleBaseContextClick"
    />
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import uniqid from 'uniqid';

import Categories from '../components/sidebar/Categories.vue';
import BaseContextMenu from '../components/BaseContextMenu.vue';

export default {
  name: 'Sidebar',
  components: {
    Categories,
    BaseContextMenu,
  },
  props: {
    languages: {
      type: Array,
      default: () => [],
    },
    tags: {
      type: Array,
      default: () => [],
    },
    isHidden: Boolean,
  },
  data: () => ({
    showContextMenu: false,
    contextMenuTop: 0,
    contextMenuLeft: 0,
    contextMenuItems: [
      {
        name: 'rename category',
        cb: 'editLanguageName',
      },
      {
        name: 'delete category',
        cb: 'removeLanguage',
      },
    ],
  }),
  methods: {
    ...mapActions([
      'addLanguage',
      'addSnippet',
      'editLanguageName',
      'finishEditLanguageName',
      'removeLanguage',
      'selectLanguage',
      'selectTag',
      'updateLanguageName',
    ]),
    handleAddLanguage(name) {
      let id = uniqid();
      let language = {
        id,
        name,
        isSelected: false,
        snippets: [],
        isInEditMode: false,
      };
      this.addLanguage(language);
      this.selectLanguage(id);
      this.addSnippet(uniqid());
    },
    handleUpdateLanguage({ id = null, name = null }) {
      this.updateLanguageName({ id, name });
    },
    handleShowContextMenu({ x = event.x, y = event.y, id }) {
      this.selectLanguage(id);
      this.contextMenuTop = y;
      this.contextMenuLeft = x;

      if (this.showContextMenu) {
        this.showContextMenu = false;
        setTimeout(() => {
          this.showContextMenu = true;
        }, 10);
      } else {
        this.showContextMenu = true;
      }
    },
    handleFinishEditMode() {
      this.finishEditLanguageName();
    },
    handleBaseContextClick(cb) {
      cb && this[cb]();
    },
    openModal() {
      this.$emit('openModal', 'settings');
    },
  },
};
</script>
<style lang="scss">
.Sidebar {
  width: 16%;
  min-width: 225px;
  max-width: 225px;
  padding-top: $appDistanceTop;
  position: relative;
  transition: all 0.35s $ease;
  will-change: width;

  &.is-hidden {
    width: 0;
    min-width: 0;
  }

  .Logo {
    position: absolute;
    bottom: $appDistanceBottom * 1.35;
    left: 50%;
    transform: translateX(-50%);
    display: block;
    width: 50%;
    user-select: none;
    display: none;
  }

  .Icon--settings {
    position: absolute;
    right: 20px;
    top: 54px;
    cursor: pointer;
    z-index: zIndex(default);
  }
}
</style>
